import { cn } from "lib/utils";
import { Pages } from "types/common";
import { handleLinkClick, generateLink } from "lib/links";
import styles from "./disclaimer.module.css";

export default function Disclaimer({
  className,
  page,
}: {
  className?: string;
  page: Pages;
}) {
  const isQuiz = page === "family" || page === "education";

  return (
    <p className={cn(styles.text, className)}>
      {isQuiz ? (
        <>
          This quiz is meant for information only and should not be relied upon
          as financial advice, recommendation or solicitation for any insurance
          products. Any opinion or information contained in this quiz is made on
          a general basis and should not be relied upon by the readers as
          advice.
        </>
      ) : (
        <>
          This simulator is designed for informational and illustrative purposes
          only, and helps you estimate the{" "}
          {page === "wealth"
            ? "difference in finances, assuming you start now or 5 years later. It assumes an 8%"
            : "finances you may require for your retirement. It assumes a modest inflation rate of 2% p.a. and an"}{" "}
          annual rate of return that is divided into 12 months, with interest
          earned accrued on a monthly basis.
        </>
      )}{" "}
      For details on the {isQuiz ? "quiz" : "simulator"}, the Meet the Assurance
      Manager (S$20 cash) promotion, {!isQuiz && "and assumptions used, "}see
      the{" "}
      <a
        onClick={(e) => handleLinkClick(e, page)}
        href={generateLink("disclaimer", page)}
        target="_top"
        className={styles.link}
      >
        full disclaimer
      </a>{" "}
      below.
    </p>
  );
}
